module.exports = __webpack_public_path__ + "static/logo-black-192-61bdc1f8a4ce1267123a1aae194f6747.png";